/**
 * Retrieves the translation of text.
 */
import { __ } from "@wordpress/i18n";
import {
  useBlockProps,
  InspectorControls,
  MediaUpload,
  MediaUploadCheck,
} from "@wordpress/block-editor";
import {
  PanelBody,
  PanelRow,
  SelectControl,
  Spinner,
  Button,
} from "@wordpress/components";
import { useEffect, useState, useCallback } from "@wordpress/element";

export default function Edit({ attributes, setAttributes }) {
  const blockProps = useBlockProps();
  const { loopTemplate, partnerChosenTaxonomy, backgroundImage } = attributes;

  const bgImgByDefault = "/wp-content/themes/frost/assets/images/green_bg.jpg";

  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [taxonomies, setTaxonomies] = useState([]);

  const fetchPartnersTaxonomies = useCallback(() => {
    setLoading(true);
    setError(null);

    wp.apiFetch({
      path: "/wp/v2/partner-type?per_page=10",
    })
      .then((taxonomies) => {
        setTaxonomies(taxonomies);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching partners taxonomies:", error);
        setError(__("Failed to fetch partners taxonomies.", "partners-block"));
        setLoading(false);
      });
  }, []);

  const fetchPosts = useCallback(() => {
    setLoading(true);
    setError(null);

    wp.apiFetch({
      path: `/wp/v2/membres_partner?per_page=3&page=1&_embed=true&acf_format=standard`,
    })
      .then((posts) => {
        setPosts(posts);
        console.log("leposts: ", posts);

        posts.forEach((post, index) => {
          console.log(`Post ${index + 1}:`);
          console.log("Title:", post.title.rendered);
          console.log(
            "ACF Taxonomies:",
            post.acf && post.acf.taxonomies
              ? post.acf.taxonomies
              : "No ACF data found"
          );
        });

        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching partners:", error);
        setError(__("Failed to fetch partners.", "partners-block"));
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    fetchPosts();
    fetchPartnersTaxonomies();
  }, [fetchPosts, fetchPartnersTaxonomies]);

  return (
    <div {...blockProps}>
      <InspectorControls>
        <PanelBody title={__("Settings", "partners-block")}>
          <PanelRow>
            <SelectControl
              label={__("Loop Template", "partners-block")}
              value={loopTemplate}
              options={[
                {
                  label: __("Template 1: row", "partners-block"),
                  value: "template-1",
                },
              ]}
              onChange={(value) => setAttributes({ loopTemplate: value })}
              defaultValue="template-1"
            />
          </PanelRow>
          <PanelRow>
            <SelectControl
              label={__("Select Taxonomies", "partners-block")}
              value={partnerChosenTaxonomy}
              options={taxonomies.map((taxonomy) => ({
                label: taxonomy.name,
                value: taxonomy.slug,
              }))}
              onChange={(value) =>
                setAttributes({ partnerChosenTaxonomy: value })
              }
              defaultValue={taxonomies.length > 0 ? taxonomies[0].slug : ""}
            />
          </PanelRow>
          <PanelRow>
            <label>{__("Background Image for Cards", "partners-block")}</label>
          </PanelRow>
          <PanelRow>
            <MediaUploadCheck>
              <MediaUpload
                onSelect={(media) =>
                  setAttributes({ backgroundImage: media.url })
                }
                allowedTypes={["image"]}
                render={({ open }) => (
                  <Button variant="secondary" onClick={open}>
                    {__(
                      backgroundImage
                        ? "Replace Background Image"
                        : "Select Background Image",
                      "partners-block"
                    )}
                  </Button>
                )}
              />
            </MediaUploadCheck>
            {backgroundImage && (
              <Button
                variant="link"
                isDestructive
                onClick={() => setAttributes({ backgroundImage: "" })}
              >
                {__("Remove Background Image", "partners-block")}
              </Button>
            )}
          </PanelRow>
        </PanelBody>
      </InspectorControls>
      <div className="my-partners-block">
        <h2>Selected Taxonomy: {partnerChosenTaxonomy}</h2>
        {loading ? (
          <Spinner />
        ) : error ? (
          <div className="error-message">{error}</div>
        ) : (
          <ul className="d-flex flex-wrap flex-row">
            {posts.map((post) => (
              <li
                key={post.id}
                className={`d-flex  flex-column ${loopTemplate}`}
              >
                <article
                  className={`d-flex  flex-column`}
                  style={{ width: "100%" }}
                >
                  <div
                    className="partner-block-image"
                    style={{
                      backgroundImage: backgroundImage
                        ? `url(${backgroundImage})`
                        : bgImgByDefault,
                    }}
                  >
                    {post._embedded?.["wp:featuredmedia"]?.[0]?.source_url ? (
                      <img
                        src={post._embedded["wp:featuredmedia"][0].source_url}
                        alt={post?.title?.rendered || "No title"}
                        style={{ height: "100%" }}
                      />
                    ) : (
                      <div className="placeholder-image">No Image</div>
                    )}
                  </div>
                  <div
                    className="d-flex flex-column"
                    style={{ padding: "24px 32px 16px", background: "#fff" }}
                  >
                    <h3>{post?.title?.rendered || "Untitled"}</h3>
                    <p
                      dangerouslySetInnerHTML={{
                        __html:
                          post?.content?.rendered
                            ?.split(" ")
                            .slice(0, 25)
                            .join(" ") + "..." || "No description available",
                      }}
                    ></p>
                    <div className="extra-content d-flex">
                      <p className="lireplus d-flex">Lire plus +</p>
                      <p className="siteweb d-flex">Site Web</p>
                    </div>
                  </div>
                </article>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
